import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPracticeSolutionRequest,
} from "../../../../redux/exam_analytics/analyticsSlice";

import QuestionText from "../../../../components/analytics/components/QuestionWise/QuestionText";
import QuestionGridNumber from "../../../../components/analytics/components/QuestionWise/QuestionGridNumber";
import { ClipLoader } from "react-spinners";

import "./ViewSolution.css";

export default function ViewSolution() {
  const dispatch = useDispatch();

  /* ---------------- REDUX STATE ---------------- */
  const { practiceSolution, loading, error } = useSelector(
    (state) => state.analyticsSlice
  );

  const { paperId, testType, testDetails } = useSelector(
    (state) => state.examSlice
  );

  /* ---------------- DERIVED VALUES ---------------- */
  const finalPaperId = paperId || testDetails?.paper_id;
  const finalSetId = testDetails?.setId || testDetails?.set_id;
  const finalPaperType = testType?.id;

  /* ---------------- LOCAL STATE ---------------- */
  const [selectedIndex, setSelectedIndex] = useState(0);

  /* ---------------- FETCH PRACTICE SOLUTION ---------------- */
  useEffect(() => {
    if ((finalPaperId || finalSetId) && finalPaperType) {
      dispatch(
        fetchPracticeSolutionRequest({
          paperId: finalPaperId,
          setId: finalSetId,
          paperType: finalPaperType,
        })
      );
    }
  }, [dispatch, finalPaperId, finalSetId, finalPaperType]);

  /* ---------------- STATES ---------------- */

  if (loading?.practice) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <ClipLoader color="#C61C26" size={50} />
      </div>
    );
  }

  if (error?.practice) {
    return (
      <div style={{ padding: 20 }}>
        <p>Error: {error.practice}</p>
      </div>
    );
  }

  const questions = practiceSolution?.data || [];

  if (!questions.length) {
    return (
      <div style={{ padding: 20 }}>
        No questions available.
      </div>
    );
  }

  /* ---------------- UI ---------------- */

  return (
    <div className="questionPage_wrapper">
      
      {/* LEFT SIDE - QUESTION */}
      <div className="questionPage_left">
        <QuestionText data={questions[selectedIndex]} />
      </div>

      {/* RIGHT SIDE - GRID */}
      {/* <div className="questionPage_right">
        <QuestionGridNumber
           data={questions}
    selectedIndex={selectedIndex}
    onSelect={setSelectedIndex}
        />
      </div> */}

      {/* BOTTOM NAVIGATION */}
      <div className="bottom_nav_buttons">
        <button
          onClick={() =>
            setSelectedIndex((prev) =>
              prev > 0 ? prev - 1 : prev
            )
          }
          disabled={selectedIndex === 0}
        >
          Previous
        </button>

        <button
          onClick={() =>
            setSelectedIndex((prev) =>
              prev < questions.length - 1 ? prev + 1 : prev
            )
          }
          disabled={selectedIndex === questions.length - 1}
        >
          Next
        </button>
      </div>

    </div>
  );
}